import request from '@/utils/request'

export function getList (filters, pagination) {
  return request({
    url: '/log',
    method: 'get',
    headers: {
      'X-filters': JSON.stringify(filters),
      'X-pagination': JSON.stringify(pagination)
    }
  })
}

export function getDashboardData () {
  return request({
    url: `/dashboard_data`,
    method: 'get'
  })
}
